import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import {
  Col,
  // Container,
  Row,
  // Table,
  // Button,
  Image,
  Modal,
  Form,
} from "react-bootstrap";

import {
  // Paper,
  // InputBase,
  // IconButton,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core";
// import SearchIcon from "@material-ui/icons/Search";
import { useFormik } from "formik";
import * as yup from "yup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  superadmin_add_faq,
  superadmin_update_faq_by_id,
} from "../../../../store/actions/SuperAdminActions/superAdminFAQAction";
import {
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import isEmpty from "../../../../store/validation/is-Empty";

const validationSchema = yup.object({
  category: yup.string().required("Category is required"),
  subCategory: yup.string().required("Subcategory is required"),
  role: yup.array().min(1, "Role is required"),
  question: yup
    .string()
    .required("Question is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  answer: yup
    .string()
    .required("Answer is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const checkboxes = [
  { id: 0, text: "User" },
  { id: 1, text: "Merchant" },
  { id: 2, text: "Super Admin" },
  { id: 5, text: "Amealio website" },
];

export const SuperAdminEditFAQ = (props) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleShow = () => {
    formik.resetForm();
    setShow(!show);
  };
  const [allCategory, setCategory] = useState([]);
  const [allSubCategory, setSubCategory] = useState([]);

  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user.accessToken : "";
  });
  const loader = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.secondary_loader : "";
  });

  const onChange = (id) => {
    const selectedCheckboxes = formik.values.role;
    const findIdx = selectedCheckboxes.indexOf(id);
    if (findIdx > -1) {
      selectedCheckboxes.splice(findIdx, 1);
    } else {
      selectedCheckboxes.push(id);
    }
    formik.setFieldValue("role", selectedCheckboxes);
  };

  const onCategoryHandleChange = (e) => {
    formik.setFieldValue("category", e.target.value);
  };

  const onSubCategoryHandleChange = (e) => {
    formik.setFieldValue("subCategory", e.target.value);
  };

  const formik = useFormik({
    initialValues: {
      category: props.editedData && props.editedData.category_id._id,
      subCategory: props.editedData && props.editedData.sub_category_id._id,
      role: props?.editedData?.role || [],
      // props.editedData && props.editedData.role,
      question: props.editedData && props.editedData.question,
      answer: props.editedData && props.editedData.answer,
    },
    validationSchema,

    onSubmit: (values) => {
      var formData = {};
      formData.category_id = values.category;
      formData.sub_category_id = values.subCategory;
      formData.role = values.role;
      formData.question = values.question;
      formData.answer = values.answer;
      dispatch(
        superadmin_update_faq_by_id(
          props?.editedData?._id,
          formData,
          token,
          onAddSuccess
        )
      );
      // console.log(formData);
    },
  });

  const onAddSuccess = () => {
    formik.resetForm();
    handleShow();
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  /************************************
   * @DESC GET ALL CATEGORY
   ************************************/
  useEffect(() => {
    dispatch(getAllCateogryForIcons(onSuccessGetFavChain));
  }, []);

  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];
    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id });
    }
    setCategory(cateogryIcons);
  };

  useEffect(() => {
    dispatch(
      getSubCateogryWithCategoryId(
        onSuccessGetSubCategory,
        formik.values.category
      )
    );
  }, [formik.values.category]);

  /***************************************
   * @DESC GET SUBCATEGORY BY CATEGORY ID
   **************************************/
  const onSuccessGetSubCategory = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].status === "APPROVED")
        subC.push({
          icon_code: data[i].icon_code,
          name: data[i].title,
          id: data[i]._id,
          icon: data[i].icon,
          description: data[i].description,
        });
    }
    setSubCategory(subC);
  };

  useEffect(() => {
    if (formik.errors && formik.errors.category) {
      let categorytElement = document.getElementById("category");
      categorytElement.focus();
    } else if (formik.errors && formik.errors.subCategory) {
      let subCategoryElement = document.getElementById("subCategory");
      subCategoryElement.focus();
    }
    // else if (formik.errors && formik.errors.role) {
    //   let roleElement = document.getElementById("role");
    //   roleElement.focus();
    // }
    else if (formik.errors && formik.errors.question) {
      let questionElement = document.getElementById("question");
      questionElement.focus();
    } else if (formik.errors && formik.errors.answer) {
      let answerElement = document.getElementById("answer");
      answerElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      {props.type === "add" && (
        <button className="btn btn-danger btn2 btn-lg" onClick={handleShow}>
          + Add FAQs
        </button>
      )}
      {props.type === "edit" && (
        <div className="enIconBtn mr-3" onClick={handleShow}>
          <Image
            src={require("../../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit catalog"
            title="Edit catalog"
            fluid
          />
        </div>
      )}
      <Modal
        show={show}
        onHide={handleShow}
        centered
        size="md"
        className="admin_vendor_details_popup"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="modal_title_header">
            {props.type === "add" && "Add FAQs"}
            {props.type === "edit" && "Edit FAQs"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-outlined-label">
                Category
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="category"
                name="category"
                value={formik.values.category}
                onChange={onCategoryHandleChange}
                label="Category"
              >
                {allCategory &&
                  allCategory.map((category, index) => {
                    return (
                      <MenuItem value={category.id} key={index}>
                        {category.name}
                      </MenuItem>
                    );
                  })}
              </Select>
              {formik.errors.category && formik.touched.category ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.category}
                </div>
              ) : null}
            </FormControl>
            <div className="mt-3 mb-2">
              <div className="row">
                <div className={loader && loader ? "col-11" : "col-12"}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Sub Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="subCategory"
                      name="subCategory"
                      value={formik.values.subCategory}
                      onChange={onSubCategoryHandleChange}
                      label="Sub Category"
                    >
                      {allSubCategory &&
                        allSubCategory.map((category, index) => {
                          return (
                            <MenuItem value={category.id} key={index}>
                              {category.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                    {formik.errors.subCategory && formik.touched.subCategory ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.subCategory}
                      </div>
                    ) : null}
                  </FormControl>
                </div>
                {loader && loader ? (
                  <div className="col-1 p-0 d-flex align-items-center">
                    <Loader
                      type="Puff"
                      color="#00BFFF"
                      height={25}
                      width={25}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mt-3 mb-2">
              <div className="f12-500">Select Role</div>
              <Row className="px-3 py-2">
                {checkboxes.map((checkbox, index) => (
                  <Col md={3} className="p-1 f11-500" key={index}>
                    <label key={checkbox.id}>
                      <input
                        type="checkbox"
                        defaultChecked={formik.values.role.includes(
                          checkbox.id
                        )}
                        onChange={() => onChange(checkbox.id)}
                        checked={formik.values.role.includes(checkbox.id)}
                        value={checkbox.id}
                        // selected={formik.values.role.includes(checkbox.id)}
                      />
                      {"  "}
                      {checkbox.text}
                    </label>
                  </Col>
                ))}
              </Row>
              {formik.errors.role && formik.touched.role ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.role}
                </div>
              ) : null}
            </div>
            <div className="mt-3 mb-2">
              <TextField
                id="question"
                label="Question"
                type="text"
                multiline
                rows="4"
                variant="outlined"
                className={`w-100 ${
                  formik.errors.question && formik.touched.question
                    ? "enError"
                    : ""
                }`}
                name="question"
                onChange={formik.handleChange}
                value={formik.values.question}
                onBlur={formik.handleBlur}
                fullWidth
              />
              {formik.errors.question && formik.touched.question ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.question}
                </div>
              ) : null}
            </div>
            <div className="mt-3 mb-2">
              <TextField
                id="answer"
                label="Answer"
                type="text"
                multiline
                rows="4"
                variant="outlined"
                className={`w-100 ${
                  formik.errors.answer && formik.touched.answer ? "enError" : ""
                }`}
                name="answer"
                onChange={formik.handleChange}
                value={formik.values.answer}
                onBlur={formik.handleBlur}
                fullWidth
              />
              {formik.errors.answer && formik.touched.answer ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.answer}
                </div>
              ) : null}
            </div>
            <div className="mt-3 mb-2">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn-md mr-4 px-5 btn btn-outline-secondary"
                  onClick={() => handleShow()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-md px-5 btn btn-danger"
                  onClick={() => onClickSave()}
                >
                  {props.type === "add" && "Save"}
                  {props.type === "edit" && "Update"}
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminEditFAQ.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  superadmin_add_faq,
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
})(withRouter(SuperAdminEditFAQ));
